import { render, staticRenderFns } from "./create.vue?vue&type=template&id=2eb93c80&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb93c80')) {
      api.createRecord('2eb93c80', component.options)
    } else {
      api.reload('2eb93c80', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=2eb93c80&", function () {
      api.rerender('2eb93c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/consign/return/create.vue"
export default component.exports